<template>
    <v-container mt-1>
        <v-layout row v-if="error">
            <v-flex xs12 sm6 offset-sm3>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
                <v-form ref="userEditform" v-model="userEditFormValid" lazy-validation
                    @submit.prevent="onSignup">
                    <v-toolbar dark color="secondary">
                        <v-spacer></v-spacer>
                        <v-toolbar-title>{{title}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <ctlUserBasicInfoEdit :editUserData="editUserData"></ctlUserBasicInfoEdit>
                    <ctlUserAccountInfoEdit :editUserData="editUserData"></ctlUserAccountInfoEdit>
                    <v-layout row>
                        <v-flex xs12 text-xs-center>
                            <v-btn type="submit" color="primary">Submit</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
        </v-layout>
        <!-- {{editUserData}} -->
    </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import ctlUserBasicInfoEdit from '@/components/admin/ctlUserBasicInfoEdit'
import ctlUserAccountInfoEdit from '@/components/admin/ctlUserAccountInfoEdit'
export default {
    components: {
        'ctlUserBasicInfoEdit': ctlUserBasicInfoEdit,
        'ctlUserAccountInfoEdit': ctlUserAccountInfoEdit,
    },
    data () {
        return {
            editUserData: {
                basicInfo: {},
                accountInfo: {},
                rules: {
                    required: v => !!v || "This field is required"
                },
            },
            userEditFormValid: true,
            showLoginSection: true,
            // jobTypes: []
        }
    },
    computed: {
        id () {
            return this.$route.params.id?this.$route.params.id : null
        },
        isNew () {
            return !this.id
        },
        comparePasswords () {
            return this.password !== this.confirmPassword ? 'Passwords do not match' : true
        },
        // roles () {
        //     // console.log(this.$store.getters.user)
        //     return this.$store.getters.roles
        // },
        title () {
            return this.isNew? 'Add New User' : 'Edit User'
        },
        // jobTypes () {
        //     return this.$store.getters.loadedJobTypes.map(function (item) {
        //         return {
        //             'text': `${item.prodName} - ${item.name}`,
        //             'value': item.id }
        //     })
        // },
        user () {
            return this.$store.getters.user
        },
        // needLogin () {
        //     console.log('ss' + (this.editUserData.roles !== undefined && this.editUserData.roles.length > 0))
        //     return this.editUserData.roles !== undefined && this.editUserData.roles.length > 0
        // },
        error () {
            return this.$store.getters.error
        }
    },
    watch: {
        user (value) {
            if (value !== null && value !== undefined) {
                this.$router.push('/')
            }
        },
        'editUserData.roles': {
            handler: function (newVal, oldVal) {
                // console.log('watch editUserData changed')
                this.checkShowLoginSection()
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('adminUser', [
            'getUserEditData',
            'signUserUp',
            'updateUser',
        ]),
        async onSignup () {
            // console.log('onSignup calld')
            if (!this.$refs.userEditform.validate()) {
                return
            }

            if(this.isNew) {
                const result = await this.signUserUp(this.editUserData)
                if(result === 'successful') {
                    this.$router.push({name: 'admin-users'})
                } else {
                    alert(result)
                }

            } else {
                const result = await this.updateUser(this.editUserData)
                if(result === 'successful') {
                    this.$router.push({name: 'admin-users'})
                } else {
                    alert(result.response.data)
                }

            }
            // this.$store.dispatch('signUserUp', this.editUserData)
            // .then(data => {
            //     this.$router.push('Users')
            // })
            // .catch(data => {
            //     this.$store.commit('setError', {message: data.response.data})
            // })
        },
        onDismissed () {
            // this.$store.dispatch('clearError')
        },
        checkShowLoginSection () {
            // this.showLoginSection = (this.editUserData.roles !== undefined && this.editUserData.roles.length > 0)
        },
        // onJobTypesChanged () {
        //     console.log('watch accessJobtypes changed' + this.editUserData.accessJobtypes)
        //     if (this.editUserData.accessJobtypes.length > 1 &&
        //         this.editUserData.accessJobtypes.includes(0)) {
        //         // If last element is 0, it is All, then remove all others.
        //         // otherwise, remove All selection
        //         if (this.editUserData.accessJobtypes[this.editUserData.accessJobtypes.length - 1] === 0) {
        //             this.editUserData.accessJobtypes = [0]
        //         } else {
        //             this.editUserData.accessJobtypes = this.editUserData.accessJobtypes.filter(item => item !== 0)
        //         }
        //     }
        //     // handler: function (newVal, oldVal) {
        //     // },
        //     // deep: true
        // }
    },
    async created () {
        // if (!this.$store.getters.userIsAuthenticated) {
        //     this.$router.push('/')
        // }

        this.editUserData = await this.getUserEditData(this.id)
    },
    destroyed: function () {
        this.onDismissed()
    }
}
</script>